import { processVariable, buildWhatsAppProcessedParams } from '@chatwoot/utils';

// Constants and pure template helpers are shared with the mobile app via
// @chatwoot/utils so the logic lives in one place.
export {
  MEDIA_FORMATS,
  COMPONENT_TYPES,
  findComponentByType,
  processVariable,
} from '@chatwoot/utils';

export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_CATEGORY = 'UTILITY';

export const allKeysRequired = value => {
  const keys = Object.keys(value);
  return keys.every(key => value[key]);
};

export const applyAutomaticTemplateParameters = (
  processedParams,
  systemVariables = []
) => {
  const bodyParams = processedParams?.body;
  if (!bodyParams) return processedParams;

  systemVariables.forEach(({ key, value }) => {
    if (!key || !value || bodyParams[key] !== '') return;

    bodyParams[key] = value;
  });

  return processedParams;
};

const parseTemplateErrorDetails = details => {
  if (!details || typeof details === 'object') return details || {};

  try {
    return JSON.parse(details);
  } catch {
    return { message: details };
  }
};

export const getWhatsappTemplateErrorMessage = (error, fallbackMessage) => {
  const responseData = error?.response?.data || {};
  const parsedDetails = parseTemplateErrorDetails(responseData.details);
  const metaError = parsedDetails?.error || parsedDetails;
  const metaReason =
    metaError?.error_data?.details || metaError?.error_user_msg;
  const reason = metaReason || responseData.error || metaError?.message;
  const title = metaError?.error_user_title;

  if (title && reason && title !== reason) return `${title}: ${reason}`;
  if (reason) return reason;

  return responseData.error || fallbackMessage;
};

export const replaceTemplateVariables = (templateText, processedParams) => {
  return templateText.replace(/{{([^}]+)}}/g, (match, variable) => {
    const variableKey = processVariable(variable);
    return processedParams.body?.[variableKey] || `{{${variable}}}`;
  });
};

// The media-header flag is derived from the template inside the shared helper;
// the second argument is kept for backwards-compatible call sites.
export const buildTemplateParameters = template =>
  buildWhatsAppProcessedParams(template);
